// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"b004cf83","279":"7f970b58","302":"ce2b35ba","488":"ad73af3b","538":"90ff7dd0","640":"9564da77","789":"e8980e6d","944":"24bd8641"}[chunkId] + ".chunk.js";
};